import { TextInput, TextInputProps } from '../TextInput/TextInput';

export const NumericInput = (props: Omit<TextInputProps, 'type'>): JSX.Element => {
  return <TextInput {...props} type="number" />;
};
